module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_wrap"
  }, [_c('div', {
    staticClass: "sign_top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "phone",
    class: {
      phone_await: _vm.isPhoneAwait
    }
  }, [_c('span', {
    staticClass: "circle",
    class: {
      circle_await: _vm.isPhoneAwait
    }
  }, [_vm._v("2")]), _vm._v("验证手机\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "password",
    class: {
      password_await: _vm.isPasswordAwait
    }
  }, [_c('span', {
    staticClass: "circle",
    class: {
      circle_await: _vm.isPasswordAwait
    }
  }, [_vm._v("3")]), _vm._v("设置密码\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "done",
    class: {
      done_await: _vm.isDoneAwait
    }
  }, [_c('span', {
    staticClass: "circle",
    class: {
      circle_await: _vm.isDoneAwait
    }
  }, [_vm._v("4")]), _vm._v("注册完成\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "sign_info"
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmail),
      expression: "isEmail"
    }],
    ref: "emailForm",
    staticClass: "demo-dynamic",
    attrs: {
      "model": _vm.emailForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": "邮箱:",
      "rules": [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }
      ]
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": "",
      "placeholder": "输入邮箱，作为登录大V服务平台的登录账号"
    },
    model: {
      value: (_vm.emailForm.email),
      callback: function($$v) {
        _vm.$set(_vm.emailForm, "email", $$v)
      },
      expression: "emailForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isCode || !_vm.emailForm.email
    },
    on: {
      "click": function($event) {
        _vm.submitIcode(0, _vm.emailForm.email)
      }
    }
  }, [_vm._v("\n\t\t\t    \t\t" + _vm._s(_vm.btnTxt) + "\n\t\t\t    \t")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码:",
      "prop": "icode",
      "rules": {
        required: true,
        message: '验证码不能为空',
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入您的验证码"
    },
    model: {
      value: (_vm.emailForm.icode),
      callback: function($$v) {
        _vm.$set(_vm.emailForm, "icode", $$v)
      },
      expression: "emailForm.icode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.emailForm.icode
    },
    on: {
      "click": function($event) {
        _vm.submitEmail('emailForm')
      }
    }
  }, [_vm._v("验证邮箱")])], 1)], 1), _vm._v(" "), (_vm.isTip) ? _c('div', {
    staticClass: "tip_wrod main_word"
  }, [_c('p', [_vm._v("验证邮件已发送到邮箱")]), _vm._v(" "), _c('p', [_vm._v("若收件箱未收到，请检查垃圾箱是否有新邮件。")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPhone),
      expression: "isPhone"
    }],
    ref: "phoneForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.phoneForm,
      "rules": _vm.rules2,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号:",
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticClass: "getfocus",
    attrs: {
      "placeholder": "输入手机号，作为登录大V服务平台的登录账号"
    },
    model: {
      value: (_vm.phoneForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.phoneForm, "phone", $$v)
      },
      expression: "phoneForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isCode || !_vm.phoneForm.phone
    },
    on: {
      "click": function($event) {
        _vm.submitIcode(1, _vm.phoneForm.phone)
      }
    }
  }, [_vm._v("\n\t\t\t    \t" + _vm._s(_vm.btnTxt) + "\n\t\t\t    ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码:",
      "prop": "icode",
      "rules": {
        required: true,
        message: '验证码不能为空',
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入手机收到的大V店验证码"
    },
    model: {
      value: (_vm.phoneForm.icode),
      callback: function($$v) {
        _vm.$set(_vm.phoneForm, "icode", $$v)
      },
      expression: "phoneForm.icode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.phoneForm.icode
    },
    on: {
      "click": function($event) {
        _vm.submitPhone('phoneForm')
      }
    }
  }, [_vm._v("验证手机")])], 1)], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPass),
      expression: "isPass"
    }],
    ref: "passForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.passForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请输入您的登录密码，8~20位数字和字母组合"
    },
    model: {
      value: (_vm.passForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "pass", $$v)
      },
      expression: "passForm.pass"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "pass_tip"
  }, [_vm._v("8-20位字母和数字组合")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请再次输入您的登录密码"
    },
    model: {
      value: (_vm.passForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.passForm, "checkPass", $$v)
      },
      expression: "passForm.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.passForm.pass
    },
    on: {
      "click": function($event) {
        _vm.submitPass('passForm')
      }
    }
  }, [_vm._v("提交注册")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSign),
      expression: "isSign"
    }],
    staticClass: "sign_success"
  }, [_c('div', {
    staticClass: "main_word f20 tc mb10"
  }, [_vm._v("注册成功~~")]), _vm._v(" "), _c('p', [_vm._v("您的登录帐号为：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.emailForm.email))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.phoneForm.phone))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/suppliers/index"
    }
  }, [_c('el-button', {
    staticClass: "mt20",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("立即登录")])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email"
  }, [_c('span', {
    staticClass: "circle"
  }, [_vm._v("1")]), _vm._v("验证邮箱\n\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("如未收到，可再次点击"), _c('span', {
    staticClass: "main_word"
  }, [_vm._v("[发送验证码]")]), _vm._v("获取验证连接。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-476fa48e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/signup.vue
// module id = 521
// module chunks = 0